export default __webpack_public_path__ + "web/react/components/qrcode-overlay/images/get-app-phone.ba25ca91295f8c2fa372763d098933cd.png";